/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { environment } from "src/environments/environment";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { BehaviorSubject } from "rxjs";
import { SlotService } from "../slot/slot.service";
import { UpdateAppointmentProductsService } from "../inventory/update-appointment-products-service";
import { LiveshopService } from "../liveshop/liveshop.service";
import { PaymentService } from "../payment/payment.service";
import { InventoryService } from "../inventory/inventory-service";
import { ToastrService } from "ngx-toastr";
import { ApiCollectionService } from "../collections/api-collection.service";

@Injectable({
  providedIn: "root",
})
export class CartService {
  URL = {
    cart: "/cart",
    wishlist: "/users/favourites",
  };
  constructor(
    private http: HttpClient,
    private slotService: SlotService,
    private updateAppointmentProductsService: UpdateAppointmentProductsService,
    private liveshopService: LiveshopService,
    private paymentService: PaymentService,
    private inventoryService: InventoryService,
    private toastrService: ToastrService,
    private apiCollectionService: ApiCollectionService
  ) {}

  cartCount = new BehaviorSubject(0);

  publishCartLength() {
    let length = 0;
    for (const [key, value] of Object.entries(
      this.slotService.sizeInCartItems
    )) {
      length = length + this.slotService.sizeInCartItems[key].length;
    }
    this.cartCount.next(length);
  }

  setCartData(data, updatedProduct?) {
    this.liveshopService.aggregated = {};
    this.liveshopService.response_cart = data
      .filter((each) => each.inventoryGroup)
      .map((item) => {
        this.slotService.setCartInventoryGroupData(item);
        this.liveshopService.aggregated[item.inventoryGroup._id] =
          item.inventories;
      });
    this.liveshopService.aggregated["instantProducts"] = data.filter(
      (eachProduct) => eachProduct?.productCategoryData
    );
    this.slotService.sizeInCartItems = this.liveshopService.aggregated;
    this.updateAppointmentProductsService.cartRes.next(data);
    if (this.liveshopService.socket) {
      let aggregated = this.slotService.sizeInCartItems;
      this.liveshopService.socket.emit("updateSizeCart", {
        aggregated,
        id: this.liveshopService.socket.id,
        updatedProduct: updatedProduct,
      });
    }
    this.publishCartLength();
  }

  clearCart() {
    this.updateAppointmentProductsService
      .updateMultipleOrdersProducts(this.paymentService.ordersList, true)
      .subscribe((res) => {
        this.setCartData(res, null);
      });
  }

  createCart(data) {
    return this.http.post<any>(environment.server + this.URL.cart, data);
  }
  updateCart(data) {
    return this.http.put<any>(
      environment.server + this.URL.cart + "/" + data._id,
      data
    );
  }
  getCart(id) {
    const httpParams = new HttpParams().set("isWhiteShopUser", "true");
    return this.http.get<any>(environment.server + this.URL.cart + "/" + id, {
      params: httpParams,
    });
  }
  getWishList() {
    const httpParams = new HttpParams().set("isWhiteShopUser", "true");
    return this.http.get<any>(environment.server + this.URL.wishlist, {
      params: httpParams,
    });
  }
  addToWishList1(data) {
    return this.http.post<any>(environment.server + this.URL.wishlist, {
      inventoryGroupId: data.inventoryGroup._id,
      inventoryId: data.inventoryGroup.inventories[0].inventory,
      isFavourite: true,
    });
  }
  // updateWishList(data) {
  //   const httpParams = new HttpParams().
  //     set('isWhiteShopUser', 'true');
  //   return this.http.post<any>(environment.server + this.URL.wishlist, {
  //     inventoryGroupId: data.inventoryGroup._id,
  //     inventoryId: data.inventoryGroup.inventories[0].inventory
  //   }, { params: httpParams });
  // }
  removeFromWishList(data) {
    const httpParams = new HttpParams().set("isWhiteShopUser", "true");
    return this.http.post<any>(environment.server + this.URL.wishlist, data, {
      params: httpParams,
    });
  }
  getUserCart() {
    const httpParams = new HttpParams().set("isWhiteShopUser", "true");
    return this.http.get<any>(environment.server + this.URL.cart, {
      params: httpParams,
    });
  }
  addToWishList(data) {
    const httpParams = new HttpParams().set("isWhiteShopUser", "true");
    return this.http.post<any>(environment.server + this.URL.wishlist, data, {
      params: httpParams,
    });
  }
  removeProductFromCart(productSize) {
    let appointmentProductId = this.slotService.sizeInCartItems[
      productSize.inventoryGroup
    ]?.filter(
      (each) =>
        each.inventory._id === productSize.inventory &&
        each.appointmentCode === this.slotService.appointmentCode &&
        this.compareTextureIds(
          each.virtualProductConfigurations,
          productSize.virtualProductConfigurations
        )
    )?.[0]?.appointmentProductId;
    if (appointmentProductId) {
      let data = {
        appointmentProductId: appointmentProductId,
        appointmentCode: this.slotService.appointmentCode,
        isDelete: true,
        inventory: productSize.inventory,
      };
      this.updateAppointmentProductsService
        .updateUserCart(data)
        .subscribe((res) => {
          this.setCartData(res);
        });
    }
  }
  addProductToCart(productSize, isUserCart) {
    if (isUserCart) {
      this.inventoryService
        .inventoriesByInventoryGroup(productSize.inventoryGroup, "Size")
        .subscribe((res) => {
          res.forEach((product) => {
            if (
              product._id ===
              (productSize.inventory?._id || productSize.inventory)
            ) {
              let data = {
                isCreate: true,
                owner: {
                  type: "B2C",
                  company: JSON.parse(
                    sessionStorage.getItem("currentBusinessUnit")
                  )?.company?._id,
                  companyName: JSON.parse(
                    sessionStorage.getItem("currentBusinessUnit")
                  )?.company?.name,
                  businessUnit: productSize.businessUnitId
                    ? productSize.businessUnitId
                    : JSON.parse(sessionStorage.getItem("currentBusinessUnit"))
                        ?._id,
                },
                products: {
                  inventoryGroup: productSize.inventoryGroup,
                  inventories: {
                    inventory: product._id,
                    numberOfUnits: 1,
                    itemMaster: product.itemMaster,
                    virtualProductConfigurations:
                      productSize.virtualProductConfigurations,
                    customisation: productSize.customisation,
                  },
                  numberOfUnits: 1,
                  inventoryGroupSet: productSize.inventoryGroupSet,
                  itemMaster: product.itemMaster,
                  itemMasterGroup: product.itemMasterGroup,
                },
                inventoryData: {
                  inventory: product._id,
                  numberOfUnits: 1,
                  itemMaster: product.itemMaster,
                },
              };
              if (data) {
                this.updateAppointmentProductsService
                  .updateUserCart(data)
                  .subscribe((res) => {
                    this.setCartData(res, null);
                    if (this.apiCollectionService.wishlistDialogRef) {
                      this.apiCollectionService.wishlistDialogRef.componentInstance.removeFromWishlist(
                        {
                          inventoryGroup: {
                            _id: productSize.inventoryGroup,
                          },
                          itemMasterGroup: product.itemMasterGroup,
                          inventory: {
                            _id: product._id,
                          },
                          virtualProductConfigurations:
                            productSize.virtualProductConfigurations,
                        }
                      );
                    }
                    this.toastrService.success("Added to cart", null, {
                      timeOut: 2000,
                    });
                  });
              }
            }
          });
        });
    } else {
      let isUpdated = false;
      let updatedProduct;
      if (this.slotService.sizeInCartItems[productSize.inventoryGroup]) {
        isUpdated = true;
      }

      this.inventoryService
        .inventoriesByInventoryGroup(productSize.inventoryGroup, "Size")
        .subscribe((res) => {
          let products;
          let isNewItem = false;
          if (!isUpdated) {
            //products
            let items = [];
            res.forEach((product) => {
              if (product._id === productSize.inventory) {
                updatedProduct = product._id;
                productSize["itemMaster"] = product.itemMaster;
                productSize["itemMasterGroup"] = product.itemMasterGroup;
                isNewItem = true;
                items.push(product);
              }
            });
            products = items.map((item) => {
              if (item._id === productSize.inventory) {
                return {
                  inventory: item._id ? item._id : item,
                  numberOfUnits: 1,
                  itemMaster: item.itemMaster,
                  customisation: productSize.customisation,
                  virtualProductConfigurations:
                    productSize.virtualProductConfigurations,
                };
              }
            });
          } else {
            //updateproducts
            let items = [];
            res.forEach((product) => {
              if (product._id === productSize.inventory) {
                updatedProduct = product._id;
                productSize["itemMaster"] = product.itemMaster;
                productSize["itemMasterGroup"] = product.itemMasterGroup;
                let sizeCartProduct = this.slotService.sizeInCartItems[
                  product.inventoryGroup?._id || product.inventoryGroup
                ]?.filter(
                  (eachSizeProduct) =>
                    eachSizeProduct.inventory._id === product._id &&
                    eachSizeProduct.appointmentCode ===
                      this.slotService.appointmentCode
                );
                product["customisation"] = productSize.customisation;
                if (
                  sizeCartProduct?.length &&
                  productSize.virtualProductConfigurations?.length
                ) {
                  let textureIndex = sizeCartProduct.findIndex((cartItem) =>
                    this.compareTextureIds(
                      cartItem?.virtualProductConfigurations,
                      productSize.virtualProductConfigurations
                    )
                  );
                  if (textureIndex > -1) {
                    sizeCartProduct[
                      textureIndex
                    ].numberOfUnits += productSize.reduceQuantiy ? -1 : 1;
                  } else {
                    isNewItem = true;
                    sizeCartProduct.push({
                      inventory: product._id,
                      numberOfUnits: 1,
                      itemMaster: product.itemMaster,
                      customisation: product.customisation,
                      virtualProductConfigurations:
                        productSize.virtualProductConfigurations,
                    });
                  }
                  sizeCartProduct = sizeCartProduct.map((cartProd) => {
                    return {
                      _id: cartProd.inventory._id ?? cartProd.inventory,
                      numberOfUnits: cartProd.numberOfUnits,
                      itemMaster:
                        cartProd.inventory.itemMaster ?? cartProd.itemMaster,
                      customisation: cartProd.customisation,
                      virtualProductConfigurations: cartProd.virtualProductConfigurations.map(
                        (eachConf) => eachConf._id ?? eachConf
                      ),
                    };
                  });
                  items = [...items, ...sizeCartProduct];
                } else {
                  product.numberOfUnits =
                    sizeCartProduct.length && sizeCartProduct[0].numberOfUnits
                      ? sizeCartProduct[0].numberOfUnits +
                        (productSize.reduceQuantiy ? -1 : 1)
                      : 1;
                  isNewItem = !(
                    sizeCartProduct.length && sizeCartProduct[0].numberOfUnits
                  );
                  product["virtualProductConfigurations"] =
                    productSize.virtualProductConfigurations || [];
                  items.push(product);
                }
              } else {
                this.slotService.sizeInCartItems[
                  productSize.inventoryGroup
                ].forEach((item) => {
                  if (
                    item.inventory._id === product._id &&
                    item.numberOfUnits &&
                    item.appointmentCode === this.slotService.appointmentCode
                  ) {
                    product.numberOfUnits = item.numberOfUnits;
                    product["virtualProductConfigurations"] =
                      item.virtualProductConfigurations;
                    items.push(product);
                  }
                });
              }
            });
            products = items.map((item) => {
              return {
                inventory: item._id,
                numberOfUnits: item.numberOfUnits > -1 ? item.numberOfUnits : 1,
                itemMaster: item.itemMaster,
                customisation: item.customisation,
                virtualProductConfigurations: item.virtualProductConfigurations,
              };
            });
          }
          let data = {
            inventoryGroup: productSize.inventoryGroup,
            inventories: products,
            numberOfUnits: isUpdated ? products.length : 1,
            inventoryGroupSet: productSize.inventoryGroupSet,
            itemMaster: productSize.itemMaster,
            itemMasterGroup: productSize.itemMasterGroup,
          };
          this.updateAppointmentProductsService
            .updateAppointmentProducts(
              this.slotService.appointmentCode,
              data,
              isUpdated ? "updateProduct" : "products",
              productSize.name,
              true,
              true
            )
            .subscribe((res) => {
              this.setCartData(res, updatedProduct);
              if (!productSize.reduceQuantiy && isNewItem) {
                this.toastrService.success("Added to cart", null, {
                  timeOut: 2000,
                });
              }
            });
        });
    }
  }
  compareTextureIds(cartProducts, textures) {
    if (textures?.length || cartProducts?.length) {
      let cartConfigs = cartProducts
        ?.map((eachConf) => eachConf._id ?? eachConf)
        ?.sort()
        ?.join(",");
      let prodConfigs = textures
        ?.map((eachConf) => eachConf._id ?? eachConf)
        ?.sort()
        ?.join(",");
      return cartConfigs === prodConfigs;
    } else {
      return true;
    }
  }

  getSizeCartQuantity(inventoryGroupId, inventoryObj) {
    let quantity = 0;
    if (
      this.slotService.sizeInCartItems &&
      this.slotService.sizeInCartItems[inventoryGroupId]
    ) {
      this.slotService.sizeInCartItems[inventoryGroupId].forEach((item) => {
        if (
          item &&
          item.inventory &&
          item.inventory._id === inventoryObj?._id &&
          !inventoryObj?.isOutOfStock
        ) {
          quantity += item.numberOfUnits;
        }
      });
    }
    return quantity;
  }
}
